export const OverwriteCoordinationResultsDialogMessage = {
    modalTitle: 'Overwrite Coordination Results?',
    modalContent:
        "Coordination results exist already. Submitting for Coordination will overwrite the current results. If you'd like to coordinate again, please click Confirm.",
    primaryActionTitle: 'Confirm',
} as const;
